<template>
  <div>
    <template v-for="(group, groupIndex) in value">
      <v-card outlined class="mb-4 pa-4" :key="`group-${groupIndex}`">
        <div>
          <v-text-field
            label="Label"
            clearable
            v-model="group.label"
          ></v-text-field>
          <div>
            <div
              class="d-flex align-center"
              :key="`group-${groupIndex}-attribute-${attributeIndex}`"
              v-for="(attribute, attributeIndex) in group.attributeList"
            >
              <v-autocomplete
                :items="userAttributeList"
                item-text="label"
                item-value="name"
                v-model="attribute.attributeName"
              ></v-autocomplete>
              <v-checkbox
                class="ml-4"
                label="Required"
                v-model="attribute.required"
              ></v-checkbox>
              <v-btn
                @click="group.attributeList.splice(attributeIndex, 1)"
                class="ml-4"
                color="primary"
                outlined
                x-small
                >Remove</v-btn
              >
            </div>
          </div>
          <v-btn
            @click="group.attributeList.push({})"
            color="primary"
            outlined
            x-small
            >Add Attribute</v-btn
          >
        </div>
        <v-btn
          class="mt-8"
          @click="value.splice(groupIndex, 1)"
          color="primary"
          outlined
          small
          >Remove Group</v-btn
        >
      </v-card>
    </template>
    <v-btn
      @click="
        Array.isArray(value) ? value.push(addGroup()) : (value = [addGroup()])
      "
      color="primary"
      outlined
      small
      >Add Group</v-btn
    >
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import formElementMixin from "./formElementMixin";

export default {
  computed: {
    userAttributeList() {
      return this.attributeFilter({ entityName: "user" });
    },
    ...mapGetters({
      attributeFilter: "attribute/filter",
    }),
  },
  async created() {
    try {
      await Promise.all([this.userAttributeGetList({ reload: true })]);
    } catch (e) {
      console.error(e);
      this.$notifyError({ message: "Error loading data from server" });
      return;
    }
  },
  methods: {
    addGroup() {
      return { attributeList: [] };
    },
    ...mapActions({
      userAttributeGetList: "userAttribute/list",
    }),
  },
  mixins: [formElementMixin],
};
</script>
